import { render, staticRenderFns } from "./my-motions-component.vue?vue&type=template&id=3618226e&scoped=true"
import script from "./my-motions-component.ts?vue&type=script&lang=ts&external"
export * from "./my-motions-component.ts?vue&type=script&lang=ts&external"
import style0 from "./my-motions-component.scss?vue&type=style&index=0&id=3618226e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3618226e",
  null
  
)

export default component.exports